module.exports = __webpack_public_path__ + "static/media/3.30da4e65.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/containers/Hotel/images/carousel/3.jpg
// module id = 660
// module chunks = 6